// removed by extract-text-webpack-plugin
module.exports = {"detail":"a_b","gallery":"a_c","img":"a_e","galleryItem":"a_f","details":"a_g","list":"a_h","header":"a_i","map":"a_j"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Components.module.scss
// module id = 206
// module chunks = 0